import defineComponent from 'flight';
import $ from 'static/script/libs/jquery';
import InitData from 'static/script/app/data/init-data';

function LogBrokenAds() {

    this.intervalId = null;

    this._log = function (payload) {
        this.trigger(document, 'data:scribe', payload);
        this._removeWatcher();
    };

    this._removeWatcher = function () {
        clearInterval(this.intervalId);
    };

    this._getInitDataForScribe = function () {
        return InitData.getForScribe();
    };

    this._findBadAd = function () {

        $('body > iframe').each((i, iframe) => {
            let $iframe = $(iframe);

            if (parseInt($iframe.css('opacity')) === 0 && parseInt($iframe.css('z-index')) > 999 && $iframe.attr('name').indexOf('klarna') === -1 && $iframe.css('display') !== 'none' ) {
                console.log('Log broken ad');

                let logData = {
                    eventName: 'js-onerror',
                    message: 'Broken ad detected',
                    url: document.location.href,
                    errorObj: {
                        options: $iframe[0].outerHTML || ''
                        // initData: this._getInitDataForScribe() || ''
                    }
                };
                this._log(logData);
            }
        })
    };

    this._addWatcher = function () {
        this.intervalId = setInterval(this._findBadAd.bind(this), 3000);
        console.log('LBA');
    };

    this.after('initialize', function () {
        this._addWatcher();
        this.on(document, 'ui:teardown', this._removeWatcher.bind(this));
    });
}

module.exports = defineComponent.component(LogBrokenAds);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/log-broken-ads.js